import { useEffect } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db, auth } from "../firebase";
import { generaByFamily } from "../utils/taxonomy";

export default function AdminAuditPage() {
  useEffect(() => {
    async function runAudit() {
      // 1️⃣ Build valid genus set from taxonomy.js
      const validGenera = new Set(
        Object.values(generaByFamily)
          .flat()
          .map((g) => g.trim().toLowerCase()),
      );

      // 2️⃣ Fetch all species
      const uid = auth.currentUser?.uid;
      if (!uid) return;

      const snap = await getDocs(collection(db, "users", uid, "species"));
      const invalid = [];

      snap.forEach((doc) => {
        const data = doc.data();
        const genus = data.genus?.toString().trim().toLowerCase();

        if (!genus || !validGenera.has(genus)) {
          invalid.push({
            id: doc.id,
            name: data.name,
            storedGenus: data.genus || "(missing)",
          });
        }
      });

      console.table(invalid);
    }

    runAudit();
  }, []);

  return (
    <div className="p-6 text-sm">
      Running genus audit. Open your browser console.
    </div>
  );
}
